<template>
    <StyleCalendar v-if="calendar">
        <LoadingApp :is_full_page="false" :isLoading="isLoading" />
        <CalendarHeader>
            <button
                type="button"
                @click.prevent="prevMonth"
                :disabled="currentMonth == month"
            >
                <i class="fas fa-angle-left"></i>
            </button>
            <span>{{ MonthsEnum[month] }} - {{ year }}</span>
            <button type="button" @click.prevent="nextMonth">
                <i class="fas fa-angle-right"></i>
            </button>
        </CalendarHeader>
        <CalendarBody>
            <div class="calendar-days-of-week">
                <span>D</span>
                <span>S</span>
                <span>T</span>
                <span>Q</span>
                <span>Q</span>
                <span>S</span>
                <span>S</span>
            </div>

            <div v-for="(week, key) in calendar.weeks" :key="key">
                <span
                    v-for="(date, idx) in week"
                    :key="`${key}-${idx}`"
                    :class="{
                        disabled: date.disabled,
                        active: date.active,
                        holiday: date.holiday
                    }"
                    @click="handleSelectDate(date)"
                    @dblclick="handleSelectDateDblClick(date)"
                >
                    {{ date.day }}
                </span>
            </div>
        </CalendarBody>
        <CalendarFooter>
            <button
                type="button"
                class="btn btn-clock-delivery"
                @click="getDeliveryTimes"
            >
                <i class="far fa-clock"></i>
            </button>
            <div>
                <CancelButton type="button" @click.prevent="handleCancel">
                    Cancelar
                </CancelButton>
                <PrimaryButton type="button" @click.prevent="handleSubmit">
                    OK
                </PrimaryButton>
            </div>
        </CalendarFooter>
    </StyleCalendar>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { swall } from "../../services/sweetAlert";
import {
    StyleCalendar,
    CalendarHeader,
    CalendarBody,
    CalendarFooter
} from "./style";
import { MonthsEnum } from "../../enums/months";
import LoadingApp from "../LoadingApp.vue";
import { PrimaryButton, CancelButton } from "../Styles/Extends/styled";

export default {
    name: "CalendarDeliveryTime",
    props: {
        modal_id: {
            default: null
        },
        active_date: {
            default: null
        },
        shipping_company_id: {
            default: null
        },
        rule_id: {
            default: null
        },
        delivery_time: {
            default: null
        }
    },
    components: {
        StyleCalendar,
        CalendarHeader,
        CalendarBody,
        CalendarFooter,
        LoadingApp,
        CancelButton,
        PrimaryButton
    },
    data() {
        return {
            isLoading: false,
            colorLoading:
                this.$root?.$children[0]?.theme?.primary_color ?? "blue",
            calendar: null,
            year: null,
            month: null,
            MonthsEnum,
            dateSelected: null,
            currentDay: null,
            currentMonth: null
        };
    },
    methods: {
        ...mapActions("deliveryTimes", [
            "ActionGetCalendar",
            "setOpenCalendar",
            "ActionGetDeliveryTimes",
            "setCloseModalCalendar"
        ]),
        setCalendar() {
            let date = new Date();
            this.year = date.getFullYear();
            this.month = date.getMonth() + 1;
            this.currentMonth = date.getMonth() + 1;
            this.currentDay = date.getDate();
            this.getCalendar();
            this.markActiveDate(this.active_date);
        },
        getCalendar() {
            this.isLoading = true;
            let filters = this.getFilters();

            this.ActionGetCalendar(filters)
                .then(response => {
                    this.setOpenCalendar(false);
                    this.isLoading = false;
                    this.year = response.data.year;
                    this.month = response.data.month;
                    this.calendar = response.data;
                    this.markActiveDate(this.active_date);
                })
                .catch(error => {
                    this.isLoading = false;
                    swall(error?.msg ?? error?.message ?? error);
                });
        },
        getFilters() {
            return {
                year: this.year,
                month: this.month,
                shipping_company_id: this.shipping_company_id,
                rule_id: this.rule_id
            };
        },
        prevMonth() {
            this.month = this.calendar.last_month;
            this.year = this.calendar.last_year;
            this.getCalendar();
        },
        nextMonth() {
            this.month = this.calendar.next_month;
            this.year = this.calendar.next_year;
            this.getCalendar();
        },
        handleSelectDateDblClick(date) {
            this.handleSelectDate(date);
        },
        handleSelectDate(date) {
            this.calendar.weeks.map(week =>
                week.map(day => (day.active = false))
            );
            date.active = !date.active;
            this.dateSelected = date;

            if (date.empty_delivery_times) {
                this.$emit("openModalDeliveryTime", null);
                return;
            }
            this.getDeliveryTimes();
        },
        async getDeliveryTimes() {
            if (!this.dateSelected) {
                swall("Selecione uma data!", true);
                return;
            }
            this.isLoading = true
            await this.ActionGetDeliveryTimes(this.dateSelected)
                .then(response => {
                    this.$emit("openModalDeliveryTime", response.data);
                })
                .catch(error => swall(error?.msg ?? error?.message ?? error));
            this.isLoading = false;
        },
        handleSubmit() {
            if (!this.dateSelected) {
                swall("Selecione uma data!");
                return;
            }
            if (!this.delivery_time) {
                swall("Selecione um horário de entrega!");
                return;
            }

            this.$emit(
                "handleSelectDatetime",
                this.dateSelected,
                this.delivery_time
            );
            this.handleCancel();
        },
        handleCancel() {
            if (this.modal_id) {
                this.$root.closeModalApp(this.modal_id);
            }
        },
        markActiveDate(date) {
            if (!this.calendar) {
                return;
            }
            this.calendar.weeks.map(week =>
                week.map(day => {
                    if (day.date == date?.date) {
                        day.active = true;
                        this.dateSelected = day;
                    }
                })
            );
        }
    },
    watch: {
        openCalendar(value) {
            if (value) {
                this.dateSelected = null;
                this.setCalendar();
            }
        },
        closeModalCalendar(value) {
            if (value) {
                this.handleSubmit();
                this.setCloseModalCalendar(false);
            }
        }
    },
    computed: {
        ...mapState("deliveryTimes", ["openCalendar", "closeModalCalendar"])
    }
};
</script>
